export const app = "https://kika-api.herokuapp.com";
export const url = "https://kika-api.herokuapp.com/api/v1";
//export const url = "https://localhost:8080/api/v1";

export const products_url = "https://kika-api.herokuapp.com/api/v1/products";
export const orders_url = "https://kika-api.herokuapp.com/api/v1/orders";
export const single_product_url = `https://kika-api.herokuapp.com/api/v1/products/`;
